<template>
<div :class="['item-list', { 'search-mode': searchMode }, { 'link-mode': linkMode }]">
    <div class="item-list-inner">
        <div v-if="searchMode" class="item-list-search">
            <input type="text" v-model="searchText">
            <span class="icon-icon_search-2"></span>
        </div>
        <ul>
            <li
            v-for="(item, index) in customerList"
            :key="index"
            class="customer-item"
            :title="item.text">
                <img :src="item.image" >
                <span>
                    <template v-if="linkMode">
                        <a :href="item.link">{{ item.text }}</a>
                    </template>
                    <template v-else>
                        {{ item.text }}
                    </template>
                </span>
            </li>
            <li class="no-match" v-show="customerList.length===0"><span>{{ $t('itemList.noMatch') }}</span></li>
        </ul>
    </div>
</div>
</template>

<script>
export default {

    props: {

        list: {
            type: Array,
            default: () => []
        },
        linkMode: {
            type: Boolean,
            default: false
        },
        searchMode: {
            type: Boolean,
            default: false
        }

    },

    data () {

        return {

            searchText: ''

        };

    },

    computed: {

        customerList () {

            return this.list.filter(
                item => item.text.toLowerCase().includes( this.searchText.toLowerCase())
            );

        }

    }

};
</script>

<style lang="less">
.item-list{
    width: 430px;
    box-sizing: border-box;
    border: 1px solid #777;
    border-radius: 5px;
    position: relative;
    background-color: #fff;
    .item-list-inner{
        overflow-x: hidden;
        height: 190px;
        .item-list-search{
            position: absolute;
            top: 0;
            left: 0;
            right: 19px;
            background-color: #fff;
            padding: 4px;
            border-radius: 5px;
            input{
                box-shadow: none;
                outline: none;
                box-shadow: none;
                padding: 0;
                border: 1px solid #ccc;
                height: 46px;
                box-sizing: border-box;
                width: 100%;
                font-size: 18px;
                border-radius: 5px;
                padding: 0 16px;
            }
            span{
                position: absolute;
                right: 19px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 16px;
            }
        }
    }
    ul{
        padding: 26px 0;
        font-size: 0;
        text-align: left;
        &, li:nth-child(1), li:nth-child(2) {
            margin-top: 0 !important;
        }
        li {
            display: inline-block;
            width: 50%;
            font-size: 18px;
            text-align: left;
            &:nth-of-type(2n+1) {
                padding-left: 26px;
            }
            box-sizing: border-box;
            margin-top: 34px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            a {
                color: #333;
                &:hover{
                    color: @theme;
                }
            }
            img{
                width: 38px;
                vertical-align: middle;
                display: inline-block;
                margin-right: 12px;
            }
            span{
                vertical-align: middle;
            }
            &.no-match {
                width: auto;
                white-space: normal;
                font-size: 16px;
            }
        }
    }
    &.search-mode ul {
        padding-top: 76px;
    }
    &.link-mode ul li {
        margin-top: 10px;
        img {
            width: 40px;
        }
    }
    @media screen and (max-width: 1199px) {
        max-width: 690px;
        border-radius: 0.05rem;
        width: auto;
        .item-list-inner{
            height: 2.44rem;
            .item-list-search{
                background-color: #fff;
                right: 0.16rem;
                padding: 0.1rem;
                border-radius: 0.05rem;
                input {
                    height: 0.78rem;
                    font-size: 0.28rem;
                    border-radius: 0.05rem;
                    padding: 0 0.2rem 0 0.3rem;
                    font-weight: 500;
                }
                span{
                    right: 0.3rem;
                    font-size: 0.28rem;
                }
            }
        }
        ul {
            padding: 0.26rem 0;
            li {
                &:nth-of-type(2n+1) {
                    padding-left: 0.4rem;
                }
                margin-top: 0.5rem;
                font-size: 0.26rem;
                img{
                    width: 0.38rem;
                    margin-right: 0.2rem;
                }
                &.no-match {
                    font-size: 0.24rem;
                }
            }
        }
        &.search-mode ul {
            padding-top: 1.14rem;
        }
        &.link-mode ul li {
            margin-top: 0.26rem;
            img {
                width: 0.6rem;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/basic/itemList.vue